import { useIntl } from 'react-intl';
import { Severity } from '@tink/core/src/components/atoms/Icons/AlertIcon';
import { ScreenWrapper } from '../../../../components/atoms/ScreenWrapper/ScreenWrapper';
import { messages } from '../messages';
import { ContentBody } from '../../../../components/atoms/ContentBody/ContentBody';
import { Alert } from '../../../../components/molecules/Alert/Alert';

export type ReferBackToClientScreenProps = {
  clientName: string;
};

export const ReferBackToClientScreen: React.FC<ReferBackToClientScreenProps> = ({ clientName }) => {
  const { formatMessage } = useIntl();
  const isClientNameAbbreviated = clientName.endsWith('.');

  return (
    <ScreenWrapper>
      <ContentBody centerHorizontally centerVertically>
        <Alert
          severity={Severity.WARNING}
          title={formatMessage(messages.referBackHeadline)}
          body={[
            {
              text: formatMessage(messages.referBack, {
                clientName,
                isAbbreviated: isClientNameAbbreviated,
              }),
            },
          ]}
        />
      </ContentBody>
    </ScreenWrapper>
  );
};
